import wrapThunk from "../modules/wrap-thunk";
import { loginRequest, verifyTokenRequest } from "../modules/api/auth";
import { removeTokenFromStorage } from "../modules/token";

// Actions
const REQUEST = "superloci/auth/REQUEST";
const SUCCESS = "superloci/auth/SUCCESS";
const FAILURE = "superloci/auth/FAILURE";
const LOGOUT  = "superloci/auth/LOGOUT";

const initialState = {
    jwt: null,
    username: null,
    loggingIn: false,
    success: false,
    loginType: null,
    error: null,
};

// Reducer
export default function reducer(state = initialState, action = {}) {
    switch (action.type) {
        case REQUEST: {
            return {
                ...initialState,
                loginType: action.payload.type,
                loggingIn: true,
            };
        }
        case SUCCESS: {
            return {
                ...state,
                jwt: action.payload.jwt,
                username: action.payload.username,
                loggingIn: false,
                success: true,
            };
        }
        case FAILURE: {
            return {
                ...state,
                jwt: null,
                username: null,
                loggingIn: false,
                success: false,
                error: action.payload.error,
            }
        }
        case LOGOUT: {
            return {
                ...initialState,
            }
        }
        default:
            return state;
    }
}

// Action Creators
export function loginRequestAction(type) {
    return {
        type: REQUEST,
        payload: {
            type,
        }
    }
}
export function loginSuccessAction(username, jwt) {
    return {
        type: SUCCESS,
        payload: {
            username,
            jwt,
        },
    };
}
export function loginFailureAction(error) {
    return {
        type: FAILURE,
        payload: {
            error,
        }
    }
}

export function logoutAction() {
    return {
        type: LOGOUT,
    }
}

export const reauthenticateFromStoredToken = () => {
    return wrapThunk(async dispatch => {
        dispatch(loginRequestAction("token"));
        const verification = await verifyTokenRequest();
        if (verification.ok) {
            dispatch(loginSuccessAction(verification.username, verification.jwt));       
        } else {
            dispatch(loginFailureAction(verification.error)); 
        }
    });
};

export const loginWithCredentials = (username, password, remember = true) => {
    return wrapThunk(async dispatch => {
        removeTokenFromStorage();
        dispatch(loginRequestAction("credentials"));
        const response = await loginRequest(username, password, remember);
        if (response.ok) {
            dispatch(loginSuccessAction(username, response.jwt));
            return true;
        } else {
            dispatch(loginFailureAction('Login failed'));
            return false;
        }
    })
}

export const logout = () => {
    return wrapThunk(async dispatch => {
        removeTokenFromStorage();
        dispatch(logoutAction());
    })
}

// ----
// Selectors

export const selectLoggingIn   = (state) => state.auth.loggingIn;
export const selectLoggedIn    = (state) => state.auth.success;
export const selectUsername    = (state) => state.auth.username;
export const selectToken       = (state) => state.auth.token;
export const selectError       = (state) => state.auth.error;
export const selectLoginType   = (state) => state.auth.loginType;



// WEBPACK FOOTER //
// ./src/ducks/auth.js